module.exports = __webpack_public_path__ + "static/media/_jersey.6709730b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_jersey.svg
// module id = 2331
// module chunks = 7